import { Dispatch, createContext } from 'react';

export type MultiFactorAuthData = {
  email: string;
  password: string;
  // The account the user selected when their email exists in more than one
  // account. It must survive to the OTP-verify request; without it the backend
  // can't disambiguate the IAM user and re-prompts for account selection
  // instead of checking the code.
  account_id?: string;
};

export type MfaState = {
  user: MultiFactorAuthData | null;
  setUser: Dispatch<MultiFactorAuthData | null>;
};

export const MfaContext = createContext<MfaState | null>(null);
